import Splide from "@splidejs/splide";
import { Popup } from "./popup";
// import { windowWidth } from "./utils";

const sliders = {
  init() {
    this.setProdThumbnailsSlider();
    this.setProdThumbnailsPopup();
    this.resetSlider();
    this.topSlider();
    this.setHeroSliders();
    this.setCats();
    this.prodSliders();
    this.setBrands();
    this.blogs();
    this.divisionSliders();
    this.gallerySliders();
    this.resetPopup();

    const gallery = new Popup(
      "#jsGalleryWrap",
      "#jsOpenGallery",
      "#jsCloseGallery"
    );
    gallery.init();

    const enquirySingle = new Popup(
      "#jsEnquiryWrap",
      "#jsOpenEnquiry",
      "#jsCloseEnq"
    );
    enquirySingle.init();

    const enquire = new Popup(
      "#jsEnquiryWrap",
      "#jsOpenEnqForm",
      "#jsCloseEnq"
    );
    enquire.init();

    const bulky = new Popup("#jsBulkyWrap", "#jsOpenBulky", "#jsCloseBulky");
    bulky.init();
  },

  resetSlider() {
    window.addEventListener("reset", () => {
      this.setProdThumbnailsSlider();
      this.setProdThumbnailsPopup();
    });
  },

  resetPopup() {
    window.addEventListener("reset", () => {
      const enquire = new Popup(
        "#jsEnquiryWrap",
        "#jsOpenEnqForm",
        "#jsCloseEnq"
      );
      enquire.init();
      const gallery = new Popup(
        "#jsGalleryWrap",
        "#jsOpenGallery",
        "#jsCloseGallery"
      );
      gallery.init();
      const enqSingle = new Popup(
        "#jsEnquiryWrap",
        "#jsOpenEnquiry",
        "#jsCloseEnq"
      );
      enqSingle.init();
    });
  },

  setProdThumbnailsPopup() {
    const porductMainImages = document.getElementById("mainImagePopup") as
      | HTMLElement
      | undefined;
    const thumbnails = document.getElementById("thumbnailsPopup") as
      | HTMLElement
      | undefined;

    if (porductMainImages && thumbnails) {
      const main = new Splide(porductMainImages, {
        type: "carousel",
        pagination: false,
        arrows: true,

        breakpoints: {
          480: {
            arrows: true,
            pagination: false,
          },
        },
      });

      const thumbnailsNav = new Splide(thumbnails, {
        isNavigation: true,
        type: "carousel",
        pagination: false,
        heightRatio: 4,
        perPage: 4,
        arrow: true,
        gap: "20px",
        breakpoints: {
          767: {
            direction: "ltr",
            perPage: 3,
            heightRatio: 1,
            fixedHeight: "70px",
          },
        },
      });

      main.sync(thumbnailsNav);
      main.mount();
      thumbnailsNav.mount();
    }
  },

  topSlider() {
    const slider = document.getElementById("topSlider") as
      | HTMLElement
      | undefined;

    if (slider) {
      new Splide(slider, {
        perPage: 1,
        type: "loop",
        direction: "ttb",
        pagination: false,
        arrows: false,
        speed: 800,
        gap: "20px",
        heightRatio: 1,
        fixedHeight: "60px",
        destroy: true,
        breakpoints: {
          768: {
            destroy: false,
          },
        },
      }).mount();
    }
  },

  setHeroSliders() {
    const heroSliders = document.querySelectorAll(
      ".jsHeroSlide"
    ) as NodeListOf<HTMLElement>;
    heroSliders.forEach((el) => {
      const slider = new Splide(el, {
        perPage: 1,
        type: "loop",
        speed: 2000,
        arrows: true,
        pagination: false,
        cover: false,
        autoplay: true,
        reducedMotion: {
          interval: 4000,
          speed: 800,
          autoplay: true,
        },
        breakpoints: {
          768: {
            arrows: false,
            reducedMotion: {
              interval: 4000,
              speed: 800,
              autoplay: true,
            },
          },
        },
      });
      slider.mount();
    });
  },

  setCats() {
    const cats = document.getElementById("jsCatSlider") as
      | HTMLElement
      | undefined;

    if (cats) {
      new Splide(cats, {
        type: "carousel",
        arrows: true,
        pagination: false,
        speed: 1200,
        gap: "0",
        perPage: 4,
        destroy: true,
        rewind: false,
        breakpoints: {
          1024: {
            perPage: 3.5,
            destroy: false,
            gap: "24px",
          },

          990: {
            perPage: 3,
            destroy: false,
            gap: "24px",
          },

          768: {
            perPage: 2,
            arrows: false,
            destroy: false,
            gap: "24px",
          },

          500: {
            perPage: 1,
            arrows: false,
            gap: "15px",
            perMove: 1,
            destroy: false,
            padding: { right: "30%" },
          },
        },
      }).mount();
    }
  },

  setBrands() {
    const cats = document.getElementById("jsBrandsSlider") as
      | HTMLElement
      | undefined;

    if (cats) {
      new Splide(cats, {
        type: "carousel",
        arrows: true,
        pagination: false,
        speed: 1200,
        gap: "28px",
        perPage: 6,
        rewind: false,
        breakpoints: {
          1024: {
            perPage: 3.5,
          },

          990: {
            perPage: 3,
          },

          768: {
            perPage: 2,
            arrows: false,
          },

          500: {
            perPage: 1,
            arrows: false,
            gap: "15px",
            perMove: 1,
            padding: { right: "30%" },
          },
        },
      }).mount();
    }
  },

  blogs() {
    const slider = document.getElementById("blogs") as HTMLElement | undefined;

    if (slider) {
      new Splide(slider, {
        perPage: 4,
        type: "carousel",
        pagination: false,
        arrows: true,
        perMove: 1,
        speed: 1200,
        gap: "20px",
        breakpoints: {
          1024: {
            drag: true,
            perPage: 2.5,
            perMove: 1,
          },

          768: {
            drag: true,
            perPage: 2,
            perMove: 1,
          },

          500: {
            drag: true,
            perPage: 1,
            perMove: 1,
            padding: { right: "30%" },
          },
        },
      }).mount();
    }
  },

  prodSliders() {
    const slider = document.querySelectorAll(
      ".jsProdSliders"
    ) as NodeListOf<HTMLElement>;

    slider.forEach((slide) => {
      new Splide(slide, {
        type: "carousel",
        arrows: true,
        pagination: false,
        gap: "32px",
        perMove: 1,
        perPage: 5,
        speed: 1200,
        breakpoints: {
          1400: {
            perPage: 3,
          },

          990: {
            perPage: 3,
          },

          768: {
            perPage: 2,
            arrow: false,
          },

          500: {
            perPage: 1,
            arrows: false,
            gap: "15px",
            perMove: 1,
            padding: { right: "30%" },
          },
        },
      }).mount();
    });
  },

  gallerySliders() {
    const slider = document.querySelectorAll(
      ".jsGallerySliders"
    ) as NodeListOf<HTMLElement>;

    slider.forEach((slide) => {
      new Splide(slide, {
        type: "carousel",
        arrows: true,
        pagination: false,
        gap: "32px",
        perMove: 1,
        perPage: 5,
        speed: 1200,
        destroy: true,
        breakpoints: {
          768: {
            perPage: 2,
            arrow: false,
            destroy: false,
            gap: "30px",
          },

          500: {
            perPage: 1.5,
            arrows: false,
            gap: "15px",
            perMove: 1,
            padding: { right: "30%" },
          },
        },
      }).mount();
    });
  },

  divisionSliders() {
    const slider = document.querySelectorAll(
      ".jsDivisionSliders"
    ) as NodeListOf<HTMLElement>;

    slider.forEach((slide) => {
      new Splide(slide, {
        type: "carousel",
        arrows: true,
        pagination: false,
        gap: "32px",
        perMove: 1,
        perPage: 4,
        speed: 1200,
        breakpoints: {
          1400: {
            perPage: 3,
            arrows: false,
          },

          990: {
            perPage: 3,
            arrows: false,
            gap: "20px",
          },

          768: {
            perPage: 2,
            arrow: false,
            gap: "20px",
          },

          500: {
            perPage: 1,
            arrows: false,
            gap: "15px",
            perMove: 1,
            padding: { right: "30%" },
          },
        },
      }).mount();
    });
  },

  brands() {
    const slider = document.getElementById("jsBrandsSlider") as
      | HTMLElement
      | undefined;

    if (slider) {
      new Splide(slider, {
        type: "carousel",
        arrows: true,
        pagination: false,

        gap: "28px",

        perPage: 6,

        breakpoints: {
          1400: {
            perPage: 4,
          },

          990: {
            perPage: 4,
          },

          768: {
            perPage: 2,
            padding: { right: "30%" },
            arrows: false,
          },

          500: {
            perPage: 2,
            padding: { right: "30%" },
            arrows: false,
            gap: "15px",
            perMove: 1,
          },
        },
      }).mount();
    }
  },

  setProdThumbnailsSlider() {
    const porductMainImages = document.getElementById("mainImage") as
      | HTMLElement
      | undefined;
    const thumbnails = document.getElementById("thumbnails") as
      | HTMLElement
      | undefined;

    if (porductMainImages && thumbnails) {
      const main = new Splide(porductMainImages, {
        type: "fade",
        rewind: true,
        pagination: false,
        arrows: false,
      });

      const thumbnailsNav = new Splide(thumbnails, {
        direction: "ltr",
        isNavigation: true,
        pagination: false,
        heightRatio: 6,
        perPage: 6,
        arrows: false,
        fixedHeight: "100px",
        gap: "40px",
        breakpoints: {
          767: {
            direction: "ltr",
            perPage: 5,
            heightRatio: 5,
            gap: "20px",
            fixedHeight: "100px",
          },

          500: {
            direction: "ltr",
            perPage: 5,
            heightRatio: 5,
            gap: "20px",
            fixedHeight: "80px",
          },
        },
      });

      main.sync(thumbnailsNav);
      main.mount();
      thumbnailsNav.mount();
    }
  },
};

export default sliders;
